import React from 'react';
import { Spinner, SpinnerSize } from 'fabric-spinner/lib/components/Spinner';

const styles = require('./ItemReadingPaneHostPlaceholder.scss');

/**
 * Simple placeholder component to be shown during lazy load and item load
 * Not using MiniScreen here as it was adding to 20KB of size increase in MailBoot
 */
const ItemReadingPaneHostPlaceholder = () => (
    <div className={styles.container}>
        <Spinner size={SpinnerSize.large} />
    </div>
);

export default ItemReadingPaneHostPlaceholder;
